var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',[_vm._v("Item One")]),_c('v-tab',[_vm._v("Item Two")]),_c('v-tab',[_vm._v("Item Three")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }